import { axiosIns } from './index';
import { ApiResponse, ListApiResponse } from '../typings/ApiResponse';
import { CommentType } from '../typings/Comment';

export interface CommentImageUpload {
  key: string;
  bucket: string;
  mimetype: string;
  size: number;
}

const uploadCommentImage = async (
  formData: FormData
): Promise<ApiResponse<CommentImageUpload>> => {
  const response = await axiosIns.post(
    'carehome/comment/image/upload',
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );
  return response.data;
};

const getPresignedUrl = async (key: string): Promise<string> => {
  const response = await axiosIns.get('carehome/acp/generate-presigned-url', {
    params: { key },
  });
  return response.data?.data;
};

const addComment = async (
  content: string,
  images: CommentImageUpload[],
  safeGuardingConcerns: string | null,
  slug: string
): Promise<ApiResponse<CommentType>> => {
  const response = await axiosIns.post(`carehome/comment/${slug}`, {
    content,
    images,
    safeguarding_concerns: safeGuardingConcerns,
  });
  return response.data;
};

const getComments = async (
  slug: string,
  safeguardingConcerns: boolean,
  page: number,
  limit: number
): Promise<ApiResponse<ListApiResponse<CommentType>>> => {
  const response = await axiosIns.get(`carehome/comments/${slug}`, {
    params: {
      safeguarding_concerns: safeguardingConcerns,
      page,
      limit,
    },
  });
  return response.data;
};

const downloadComments = async (slug: string) => {
  const response = await axiosIns.get(`carehome/comments-download/${slug}`, {
    responseType: 'blob',
  });
  return response.data;
};

export {
  addComment,
  getComments,
  downloadComments,
  uploadCommentImage,
  getPresignedUrl,
};
